<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Customer Points</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /
      <b>Loyalty Point System</b>
      /
      <b>Customer Points</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- TBA -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              Customer Points
            </h4>

            <p style="font-size:bold; color: red;">
              *Please note that the export process may take a few minutes to complete
            </p>

            <json-excel
              class="btn btn-rounded btn-primary mr-1"
              style="width: 150px"
              :fetch="CallBackData"
              :fields="json_fields"
              type="csv"
              worksheet="My Worksheet"
              name="Customer Points.csv"
              >
              Excel
            </json-excel>


            <div class="input-group mb-4 d-flex flex-row-reverse p2">
              <button type="button" @click="searchFor" class="btn btn-primary">
                <i class="fas fa-search"></i>
              </button>
              <div class="form-outline ">
                <input type="input" v-model="searchItem" class="form-control" />
              </div>
            </div>
            <!-- <p>The table below shows call requests for TBA.</p> -->

            <div class="table-responsive">
              <table
                id="tba_spd_record_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th width="28%">Name</th>
                    <th width="14%">Email</th>
                    <th width="16%">Username</th>
                    <th width="8%">IC No.</th>
                    <th width="8%">Account No.</th>
                    <th width="8%">Points Earned</th>
                    <th width="8%">Points Redeemed</th>
                    <th width="8%">Points Expired</th>
                    <th width="8%">Points Available</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="user_lists.length == 0">
                    <td colspan="9">No records found</td>
                  </tr>
                  <tr v-for="(user, index) in user_lists" :key="index">
                    <td>
                      <router-link :to="redirect(user.id)">{{
                        user.name
                      }}</router-link>
                    </td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.username }}</td>
                    <td>{{ user.ic_number }}</td>
                    <td>{{ user.account_number }}</td>
                    <td>{{ user.points_earned }}</td>
                    <td>{{ user.points_redeemed }}</td>
                    <td>{{ user.points_expired }}</td>
                    <td>{{ user.points_available }}</td>
                  </tr>
                </tbody>
              </table>
              <pagination
                v-model="pageInfo.current_page"
                :per-page="pageInfo.per_page"
                :records="pageInfo.total"
                @paginate="handlePageChange"
              />
            </div>
          </div>
        </div>
        <br />
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import moment from "moment";
import Pagination from "vue-pagination-2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import JsonExcel from "vue-json-excel";

export default {
  name: "user-balance",
  components: {
    Pagination,
    Loading,
    JsonExcel,
  },
  data() {
    return {
      user_lists: [],
      pageInfo: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0
      },
      isLoading: false,
      fullPage: true,
      searchItem: null,

      json_fields: {
        "name": "name",
        "Email": "email",
        "Username": "username",
        "IC No.": "ic_number",
        "Account No.": "account_number",
        "Points Earned": "points_earned",
        "Points Redeemed": "points_redeemed",
        "Points Available": "points_available",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

      downloadApi: `/reward?export=1`
    };
  },
  
  methods: {
    async loadUserBalanceData() {
      if(!this.checkToken()) {
        return;
      }
      try {
        let result = await axios.get(axios.lpsURL + `/reward`, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.user_lists = result.data.users;
        this.pageInfo = result.data.pagination;
      } catch (e) {
        console.log(e);
      }
    },

    async CallBackData() {
      this.isLoading = true;

      this.json_data = [];

      let res = await axios.get(axios.lpsURL +this.downloadApi, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
      });

      for (let i = 0; i < res.data.length; i++) {
        this.json_data.push({
          name: res.data[i].name,
          email: res.data[i].email,
          username: res.data[i].username,
          ic_number: res.data[i].ic_number,
          account_number: res.data[i].account_number,
          points_earned: res.data[i].points_earned,
          points_redeemed: res.data[i].points_redeemed,
          points_available: res.data[i].points_available,
        });
      }

      this.isLoading = false;

      return this.json_data;
    },

    async handlePageChange(page) {
      this.isLoading = true;
      
      let api_url = '';
      if(this.searchItem == null || this.searchItem == '') {
        api_url = `/reward?page=${page}`
      } else {
        api_url = `/reward?search=${this.searchItem}&page=${page}`
      }
      
      let result = await axios.get(axios.lpsURL + api_url, {
        headers: {
          Authorization: "Bearer " + this.checkToken()
        }
      });

      this.user_lists = result.data.users;
      this.pageInfo = result.data.pagination;
      this.isLoading = false;
    },

    redirect(id) {
      return "/lps/user-balance/detail/" + id;
    },

    async searchFor() {
      this.isLoading = true;
      
      let api_url = `/reward?search=${this.searchItem}`;
      if(this.searchItem == null || this.searchItem == '') {
        api_url = `/reward`;
      }


      if(!this.checkToken()) {
        console.log('Unauthorised')
        this.isLoading = false;
        return
      }
      try {
        let result = await axios.get(axios.lpsURL + api_url, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.user_lists = result.data.users;
        this.pageInfo = result.data.pagination;
        this.isLoading = false;
        
      } catch (e) {
        console.log(e);
      }
    },

    checkToken() {
      let token = localStorage.getItem("token");

      if (token === null || token === "") {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;

      return token;
    }
  },

  async created() {
    this.isLoading = true;
    await this.loadUserBalanceData();
    this.isLoading = false;
  }
};
</script>

<style>
.spanDateTime {
  display: none;
}
</style>
